import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ICON_NAMES } from '../icons';
import { ICONS_BASE_URL } from '../tokens';

@Injectable()
export class IconRegistryService {
  private readonly matIconRegistry = inject(MatIconRegistry);
  private readonly domSanitizer = inject(DomSanitizer);

  private readonly baseUrl = inject(ICONS_BASE_URL, { optional: true });

  public registerIcons(): void {
    const path = this.baseUrl ?? 'assets/uikit-icons/';

    ICON_NAMES.forEach((name) => {
      const url = `${path}${name}.svg`;

      this.matIconRegistry.addSvgIcon(
        name,
        this.domSanitizer.bypassSecurityTrustResourceUrl(url),
      );
    });
  }
}
